import { useMutation } from "@tanstack/react-query";
import { setPasswordReg } from "@/http/userApi";

interface SetPasswordData {
  phone: string;
  password: string;
  token: string;
}

export const useSetPasswordMutation = () => {
  return useMutation({
    mutationFn: async (data: SetPasswordData) => {
      return await setPasswordReg(data.phone, data.password, data.token);
    },
  });
};
